/**
 * Size chart tab switching for guía de tallas content.
 * Supports legacy onclick="mostrarGuia('mujer')" handlers and delegated clicks on #tab-* buttons.
 */
(function () {
  if (window.__mtngSizeChartTabsInit) return;
  window.__mtngSizeChartTabsInit = true;

  const TAB_TYPES = ['mujer', 'hombre', 'ninos', 'bebes'];

  const getTabRoot = (element) =>
    element.closest('.product-size-chart-modal, .page-content, .rte, .liquid') || document;

  const activateTab = (type, scope = document) => {
    if (!TAB_TYPES.includes(type)) return;

    TAB_TYPES.forEach((name) => {
      const isActive = name === type;
      const panel = scope.querySelector(`#guia-${name}`);
      const button = scope.querySelector(`#tab-${name}`);

      if (panel) {
        panel.classList.toggle('active', isActive);
        panel.hidden = !isActive;
      }

      if (button) {
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    });
  };

  window.mostrarGuia = (type) => activateTab(type);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[id^="tab-"]');
    if (!button) return;

    const type = button.id.slice('tab-'.length);
    if (!TAB_TYPES.includes(type)) return;

    activateTab(type, getTabRoot(button));
  });
})();
